import {
  Box,
  Space
} from '@looker/components'

import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'

import _, { trim } from 'lodash'
import { useParams } from 'react-router'
import { Card } from '../Card'
import Pagination from '../Pagination/Pagination'
import { Filters } from '../Filters/Filters'
import { Backdrop, Button, IconButton, InputBase } from '@material-ui/core'

import { alpha, makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import { Close } from '@styled-icons/material-outlined'

let PageSize = 16

const tagColors = ["#f72c2c61", "#f7c82c61", "#2cf78a61", "#2cb3f761", "#f72ca961"]

export const Main: React.FC<any> = ({

}) => {
  const [data, setData] = React.useState<any[]>([])
  const [filteredData, setFilteredData] = React.useState<any[]>([])
  const [unfilteredData, setUnfilteredData] = React.useState<any[]>([])
  const [offerings, setOfferings] = React.useState<string[]>([])
  const [customerCategories, setCustomerCategories] = React.useState<string[]>([])
  const [marketScopes, setMarketScopes] = React.useState<string[]>([])
  const [availabilities, setAvailabilities] = React.useState<string[]>([])
  const [certifications, setCertifications] = React.useState<string[]>([])

  const [currentFilter, setCurrentFilter] = React.useState({})

  const [currentPage, setCurrentPage] = React.useState<number>()

  const [initialLoad, setInitialLoad] = React.useState<boolean>(true)

  const [isDataLoading, setIsDataLoading] = React.useState<boolean>(false);
  const [isDownloading, setIsDownloading] = React.useState<boolean>(false);

  const [showFilters, setShowFilters] = React.useState<boolean>(false)

  const [isMounted, setIsMounted] = React.useState<boolean>(false)

  let params = useParams();

  useEffect(() => {
    const initialize = async () => {
      fetch('/api/supplier/getData')
        .then(res => res.json())
        .then(json => {
          let _json = shuffleSort([...json]);
          setData(_json)
          setUnfilteredData(json)
          setFilteredData(json) // Initialize filteredData with the fetched data
          return json
        })
        .then(data => {
          let custCatList: string[] = [];
          let productOfferingList: string[] = [];
          let marketScopesList: string[] = [];
          let availabilitiesList: string[] = [];
          let certsList: string[] = [];
          data.forEach(row => {
            // Product Offerings Filter
            initFilters(row, 'supplier_db.product_offerings', productOfferingList);
            // Customer Category Filter
            initFilters(row, 'supplier_db.customer_categories', custCatList);
            // Market Scopes
            initFilters(row, 'supplier_db.market_scopes', marketScopesList)
            // Availabilities
            initFilters(row, 'supplier_db.availability', availabilitiesList)
            // Certifications
            initFilters(row, 'supplier_db.certifications', certsList)
          });
          setOfferings(productOfferingList);
          setCustomerCategories(custCatList);
          setMarketScopes(marketScopesList);
          setAvailabilities(availabilitiesList);
          setCertifications(certsList);
        }).then(l => { setInitialLoad(false); setIsMounted(true) }).catch(c => setInitialLoad(false))
    }

    initialize()
    setCurrentPage(1);
  }, [])

  const shuffleSort = (array) => {
    let currentIndex = array.length, randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex > 0) {

      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }

    return array;
  }

  const currentTableData = useMemo(() => {
    if (!currentPage) {
      return []
    }
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return filteredData?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, filteredData]); // Use filteredData here

  const initFilters = (row, dim, array) => {
    let rowDim: string = row[dim];
    rowDim?.split(', ').map((d: string) => {
      if (d != " ") {
        if (!array.includes(trim(d))) {
          array.push(trim(d));
        }
      }
    })
  }

  useEffect(() => {
    if (isMounted && currentFilter) {
      let data = [...unfilteredData];
      let filters = { ...currentFilter }
      let filteredData: any[] = []
      let transformFilter: string[] = []
      Object.keys(currentFilter).map(f => {
        if (currentFilter[f].length > 0) {
          currentFilter[f].map(v => {
            transformFilter.push('matches_filter(${' + f + '}, `%' + v + '%`)')
          })
        }
      })
      fetch('/api/supplier/run_query', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          filter: transformFilter.join(' AND '),
          type: 'json'
        })
      }).then(res => res.json())
        .then(d => {
          let _data = shuffleSort(d)
          setData(_data)
          setFilteredData(_data) // Update filteredData here
        })
        .then(p => setCurrentPage(1))
        .then(v => setIsDataLoading(false))
    }
  }, [currentFilter])

  const handleDataDownload = () => {
    let transformFilter: string[] = []
    Object.keys(currentFilter).map(f => {
      if (currentFilter[f].length > 0) {
        currentFilter[f].map(v => {
          transformFilter.push('matches_filter(${' + f + '}, `%' + v + '%`)')
        })
      }
    })
    setIsDownloading(true)
    fetch('/api/supplier/run_query', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        filter: transformFilter.join(' AND '),
        type: 'csv'
      })
    }).then(res => res.json())
      .then(d => downloadCSV(d, 'supplier_db.csv'))
      .then(l => setIsDownloading(false))
  }

  const downloadCSV = (data, fileName) => {
    // Create a blob with the data we want to download as a file
    const blob = new Blob([data], { type: 'csv' })
    // Create an anchor element and dispatch a click event on it
    // to trigger a download
    const a = document.createElement('a')
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const showMobileFilter = () => {
    setShowFilters(!showFilters)
  }

  const useStyles = makeStyles((theme) => ({
    grow: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: alpha(theme.palette.common.black, 0.15),
      marginRight: theme.spacing(2),
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
  }));

  const classes = useStyles();

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = event.target.value.toLowerCase();
    if (searchValue === '') {
      setFilteredData(data);
    } else {
      const result = data.filter((item) =>
        item['supplier_db.org_name'].toLowerCase().includes(searchValue)
      );
      setFilteredData(result);
    }
  };

  return (
    <>
      <Backdrop open={initialLoad} className='load-backdrop'>
        <div className='loader'></div>
      </Backdrop>
      <Space style={{ alignItems: "flex-start" }}>
        <Box style={{ width: "100%" }}>
          <Space className='data-details across'>
          <div className="flex">
            <h3 className='page-statistics mr-2'>Showing {filteredData.length} results</h3>
            <Button style={{ fontFamily: 'Poppins' }} color='primary' variant='contained' onClick={handleDataDownload} href="#">Download data</Button>
            <Button style={{ fontFamily: 'Poppins' }} color='primary' variant='contained' className='show-filter-button' onClick={showMobileFilter} href="#">Show Filters</Button>
            </div>
            {isDownloading ? <div className='loader relative-position'></div> : ''}
            <div className={classes.search} style={{backgroundColor:"#F2F5F6"}}>
              <div className={classes.searchIcon}>
                <SearchIcon />
              </div>
              <InputBase
                placeholder="Search…"
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                inputProps={{ 'aria-label': 'search' }}
                onChange={handleSearch}
              />
            </div>
          </Space>
          {isDataLoading ?
            <div className='data-loading-backdrop'>
              <div className='loader'></div>
            </div>
            :
            <>
              <div className='grid-card-layout'>
                {currentTableData?.map(d =>
                  <Card dataRow={d} offerings={offerings} />
                )}
              </div>
            </>
          }
        </Box>
        <Box style={{ width: '300px' }} className={showFilters ? "filter-section active" : "filter-section"}>
          <Space>
            <h3 >Filter By</h3>
            <IconButton onClick={showMobileFilter} className='mobile-button-exit' color='primary'><Close style={{ color: 'black', width: '20px' }} /></IconButton>
          </Space>
          <Filters
            data={data}
            offerings={offerings}
            customerCategories={customerCategories}
            marketScopes={marketScopes}
            availabilities={availabilities}
            certifications={certifications}
            currentFilter={currentFilter}
            setCurrentFilter={setCurrentFilter}
          />
        </Box>
      </Space>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={filteredData.length} // Use filteredData here
        pageSize={PageSize}
        onPageChange={page => setCurrentPage(page)}
      />
    </>
  )
}
